(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLandingHeader(root) {
    if (!root || root.dataset.landingHeaderReady === 'true') return
    root.dataset.landingHeaderReady = 'true'

    var toggle = root.querySelector('[data-landing-header-toggle]')
    var menu = root.querySelector('[data-landing-header-menu]')
    if (!toggle || !menu) return

    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open')
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
    })

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('is-open')
        toggle.setAttribute('aria-expanded', 'false')
      })
    })

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) {
        menu.classList.remove('is-open')
        toggle.setAttribute('aria-expanded', 'false')
      }
    })
  }

  function initAll() {
    document.querySelectorAll('[data-landing-header]').forEach(initLandingHeader)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-landing-header]')
    if (root) {
      delete root.dataset.landingHeaderReady
      initLandingHeader(root)
    }
  })
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(root) {
    var scope = root || document
    var triggers = scope.querySelectorAll('.lp-faq__trigger')

    triggers.forEach(function (trigger) {
      if (trigger.dataset.lpFaqReady === 'true') return
      trigger.dataset.lpFaqReady = 'true'

      trigger.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true'
        var answer = document.getElementById(this.getAttribute('aria-controls'))
        if (!answer) return

        if (expanded) {
          this.setAttribute('aria-expanded', 'false')
          answer.setAttribute('hidden', '')
        } else {
          this.setAttribute('aria-expanded', 'true')
          answer.removeAttribute('hidden')
        }
      })
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFaq() })
  } else {
    initFaq()
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFaq(event.target)
  })
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (typeof window.__lpObserver !== 'undefined') return
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lp-visible')
        observer.unobserve(entry.target)
      }
    })
  }, { threshold: 0.12 })
  window.__lpObserver = observer
  function observeAll() {
    document.querySelectorAll('.lp-fade-up').forEach(function (el) { observer.observe(el) })
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll)
  } else {
    observeAll()
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function perView() {
    if (window.innerWidth >= 900) return 3
    if (window.innerWidth >= 640) return 2
    return 1
  }

  function initCarousel(root) {
    if (!root || root.dataset.lpTestimonialsReady === 'true') return

    var track = root.querySelector('[data-lp-testimonials-track]')
    var prevBtn = root.querySelector('[data-lp-testimonials-prev]')
    var nextBtn = root.querySelector('[data-lp-testimonials-next]')
    if (!track || !prevBtn || !nextBtn) return

    var slides = track.querySelectorAll('.lp-testimonials__card')
    if (!slides.length) return

    root.dataset.lpTestimonialsReady = 'true'
    var index = 0

    function maxIndex() {
      return Math.max(0, slides.length - perView())
    }

    function slideOffset() {
      var first = slides[0]
      if (!first) return 0
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24
      return index * (first.offsetWidth + gap)
    }

    function update() {
      index = Math.min(index, maxIndex())
      track.style.transform = 'translate3d(-' + slideOffset() + 'px, 0, 0)'
      prevBtn.disabled = index <= 0
      nextBtn.disabled = index >= maxIndex()

      var needsNav = slides.length > perView()
      prevBtn.hidden = !needsNav
      nextBtn.hidden = !needsNav
    }

    prevBtn.addEventListener('click', function () {
      index = Math.max(0, index - 1)
      update()
    })

    nextBtn.addEventListener('click', function () {
      index = Math.min(maxIndex(), index + 1)
      update()
    })

    var resizeTimer
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(update, 100)
    })

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () { update() })
      ro.observe(track.parentElement)
    }

    update()
  }

  function initAll() {
    document.querySelectorAll('[data-lp-testimonials]').forEach(initCarousel)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-testimonials]')
    if (root) {
      delete root.dataset.lpTestimonialsReady
      initCarousel(root)
    }
  })
})()

  } catch(e) { console.error(e); }
})();
})();
